module.exports = __webpack_public_path__ + "static/img/app-logo.73ebca1b.png";